import type { CosignatureQueueResponse, CosignatureQueueSearchParams } from "@/core/types";
import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";

export async function getCosignatureQueue(
  searchParams?: CosignatureQueueSearchParams,
  signal?: AbortSignal,
): Promise<CosignatureQueueResponse> {
  return cosignatureRequestsTyped.get_cosign_queue({ searchParams, signal });
}
